// const url = "http://127.0.0.1:8000";
const url = 'https://adherent-app-783f8874404b.herokuapp.com';
export default url;

